import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class OutboundCampaignService {

  constructor(private httpClient:HttpClient) { }

  runBatch(aiAgentNumber:number,formData:FormData){
    return this.httpClient.post<any>(`${environment.outboundCampaignUrl}/runBatch/${aiAgentNumber}`,formData);
  }
  scheduleBatch(aiAgentNumber:number,targetDate:Date,formData:FormData){
    return this.httpClient.post<any>(`${environment.outboundCampaignUrl}/scheduleBatch/${aiAgentNumber}/${targetDate}`,formData);
  }
  deleteBatch(id:number){
    return this.httpClient.delete<any>(`${environment.outboundCampaignUrl}/${id}`);
  }
}
